var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","bottom":"0","width":"100%"}},[(_vm.isRender)?_c('temp-render',{ref:'temp-' + _vm.code,attrs:{"code":_vm.code,"attr":_vm.tempObj},on:{"action":_vm.handleOpenLocalPath}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }